import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../mock";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="border-t border-slate-200/80 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-5 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            FAQ
          </p>
          <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-[#1e1b4b] sm:text-5xl">
            Questions, <span className="text-slate-400">answered.</span>
          </h2>
        </div>

        <div className="mt-12 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <button
                key={f.q}
                onClick={() => setOpen(isOpen ? -1 : i)}
                className="flex w-full flex-col px-5 py-5 text-left transition-colors hover:bg-slate-50/60"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="text-[15px] font-medium text-[#1e1b4b]">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                      isOpen
                        ? "border-[#d4af37] bg-[#d4af37]/10 text-[#d4af37]"
                        : "border-slate-200 text-slate-500"
                    }`}
                  >
                    {isOpen ? <Minus className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
                  </span>
                </div>
                <div
                  className={`grid overflow-hidden transition-all duration-300 ${
                    isOpen ? "mt-3 grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="min-h-0 pr-10 text-sm leading-relaxed text-slate-600">
                    {f.a}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
